var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.quest ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Quest')
    }
  })], 1) : _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm.quest.name ? _c('span', [_vm._v(_vm._s(_vm.quest.name))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Quest')) + " " + _vm._s(_vm.id))])]), _vm.quest.stamina && _vm.quest.stamina != -1 ? _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size() / 2.5,
      "tile": ""
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.commonuiatlas.format('StaminaIcon') + '.png',
      "contain": ""
    }
  })], 1), _c('small', [_vm._v(" " + _vm._s(_vm.quest.stamina))])], 1) : _vm._e(), _vm.quest.exId2 && _vm.quest.exId2 != -1 ? _c('div', {
    staticClass: "float-right pr-4"
  }, [_c('v-avatar', {
    attrs: {
      "size": _vm.$size() / 2.5
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.itemicon.format(_vm.quest.exId2) + '.jpg'
    }
  })], 1), _vm.quest.ex2Amount != 1 ? _c('small', [_vm._v(" " + _vm._s(_vm.quest.ex2Amount))]) : _vm._e()], 1) : _vm._e(), _c('p', {
    staticClass: "px-4 primary--text"
  }, [_vm.questLibrary.category == 5 ? _c('span', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.CharacterList[_vm.quest.section].m_Name)) + " — " + _vm._s(_vm.$t('Quest Library Categories.5')))]) : _vm.questLibrary.category == 6 ? _c('span', [_vm._v(_vm._s(_vm.$t('Section').format(_vm.quest.section)) + " — " + _vm._s(_vm.$t('Quest Library Categories.6')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Section').format(_vm.quest.section)) + " — " + _vm._s(_vm.$name(_vm.questLibrary.name)))])]), _c('ItemList', {
    attrs: {
      "items": _vm.items,
      "amounts": _vm.amounts,
      "gold": _vm.quest.rewardMoney
    }
  }), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_vm.quest.rewardUserExp ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('User Exp'),
      "v": _vm.quest.rewardUserExp
    }
  }) : _vm._e(), _vm.quest.rewardCharacterExp ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Character Exp'),
      "v": _vm.quest.rewardCharacterExp
    }
  }) : _vm._e(), _vm.quest.rewardFriendshipExp ? _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Friendship Exp'),
      "v": _vm.quest.rewardFriendshipExp
    }
  }) : _vm._e()], 1), _vm.questLibrary.category == 4 ? _c('v-list-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$i18n.locale == 'ja',
      expression: "$i18n.locale=='ja'"
    }],
    attrs: {
      "target": "_blank",
      "href": _vm.$const.wikiwiki.quest.format("".concat(_vm.questLibrary.badge.replace('.', '年'), "\u6708\u30C1\u30E3\u30EC\u30F3\u30B8\u30AF\u30A8\u30B9\u30C8"))
    }
  }, [_c('v-list-item-title', {
    staticClass: "primary--text"
  }, [_vm._v("イベント攻略 - " + _vm._s(_vm.$t('Wikiwiki.Title')))]), _c('v-list-item-action', {
    staticClass: "ma-0"
  }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1)], 1) : _vm._e(), _c('v-divider'), _c('Ad', {
    key: "quest-ad-".concat(_vm.id)
  }), !_vm.isOpen ? [_c('v-divider', {
    staticClass: "mb-8"
  }), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('v-icon', {
    attrs: {
      "size": "64"
    }
  }, [_vm._v("mdi-lock")])], 1), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_vm._v(_vm._s(_vm.openTime.toLocaleString()))])])] : [_vm._l(_vm.quest.waveIDs, function (wave, i) {
    return [_c('v-divider', {
      staticClass: "mb-4"
    }), _c('p', {
      staticClass: "title px-4 primary--text"
    }, [_vm._v(_vm._s(_vm.$t('Wave')) + " " + _vm._s(i + 1))]), _c('Wave', {
      key: "quest-wave-".concat(wave),
      attrs: {
        "id": wave,
        "qid": _vm.id
      }
    })];
  })]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }